import { observer } from 'mobx-react';
import React from 'react';
import { Route, Routes } from 'react-router-dom';

import GradeBreakdown from 'modules/GradeBreakdown';
import { MonthCalendarProvider } from 'modules/GradeBreakdown/Context';

import GradeBookTabs from '../components/GradeBookTabs';
import GradeBook from '../pages/GradeBook';

function GradeBookRoute() {
	return (
		<Routes>
			<Route
				path="month"
				element={
					<GradeBookTabs>
						<MonthCalendarProvider>
							<GradeBreakdown />
						</MonthCalendarProvider>
					</GradeBookTabs>
				}
			/>
			<Route
				path="*"
				element={
					<GradeBookTabs>
						<GradeBook />
					</GradeBookTabs>
				}
			/>
		</Routes>
	);
}

export default observer(GradeBookRoute);
